export enum StatoPagamentoEnum {
  IN_ATTESA = 'IN ATTESA',
  PAGATO = 'PAGATO'
}
